import { useQuery } from "react-query"

import axios from "axios"

import { formatCurrency, formatTime } from "@/core/utils/formatter"
// [TODO] the follwoing line will be removed
// import purchaseDetailData from "@/modules/sign-up/api/__fixtures__/purchase-detail.json"

import {
  FailureMessage,
  ServiceFailedToReturn,
  ServiceError,
  PurchaseDetailFetchType,
  PurchaseDetailType,
} from "./types"
import { customerBaseApi, purchaseDetailGetPath } from "./utils"

const transformPurchaseResponse = (respondData: string) => {
  const data = JSON.parse(respondData)

  if (data?.code) {
    return respondData
  }

  const { amount, created, seller, currency, developerMessage } =
    data as PurchaseDetailFetchType & ServiceError

  if (developerMessage) {
    return respondData
  }

  const {
    name,
    receiptName,
    phoneNumber: orgPhoneNumber,
    contactEmail: orgContactEmail,
    privacyPolicyLink: orgPrivacyPolicyLink,
  } = seller ?? { name: "" }

  const { profileImageUrl } = seller ?? {}
  const orgLogoUrl = (profileImageUrl ?? "").replace("[size]", "m")

  const receiptAmount = formatCurrency(amount, currency)
  const receiptTime = formatTime(created)

  return {
    orgName: receiptName ?? name,
    orgLogoUrl,
    receiptAmount,
    receiptTime,
    orgPhoneNumber,
    orgContactEmail,
    orgPrivacyPolicyLink,
  }
}

export const usePurchaseDetailFetch = (orgUuid: string, purchaseUuid: string) => {
  const getData = async () => {
    try {
      const { data } = await axios.get(
        customerBaseApi(purchaseDetailGetPath(orgUuid, purchaseUuid)),
        {
          responseType: "json",
          validateStatus: (status: number) => status === 200,
          transformResponse: transformPurchaseResponse,
        },
      )

      return data
    } catch (err: any) {
      if (err.response?.status === 404) {
        return {
          failureMessage: FailureMessage.PURCHASE_NOT_FOUND,
        }
      }

      // [TODO] will be removed
      // if (process?.env?.NODE_ENV === "development") {
      //   return transformPurchaseResponse(JSON.stringify(purchaseDetailData))
      // }
      return {
        failureMessage: FailureMessage.OPERATION_ERROR,
      }
    }
  }

  return useQuery<PurchaseDetailType & ServiceFailedToReturn, { message: string }>(
    "purchase-details",
    getData,
    {
      retry: 0,
      refetchOnWindowFocus: false,
      enabled: !!purchaseUuid,
    },
  )
}
